export interface OfficerProfileProps {
    officerImagePath: string;
    name: string;
    title: string;
}

const OfficerProfile = ({ officerImagePath, name, title }: OfficerProfileProps) => {
    return (
        <div
            className="officer-profile"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
                width: "100%",
                maxWidth: "340px",
                //boxSizing: "border-box",
                margin: "12px",
                padding: "20px",
                border: "1px solid #ddd",
                backgroundColor: "#141619",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
        >
            <img
                src={officerImagePath}
                alt="officer"
                style={{
                    width: "230px",
                    height: "230px",
                    objectFit: "cover",
                    borderRadius: "8px"
                }}
            />

            <div style={{ textAlign: "center", marginTop: "8px" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "center" }}>
                    <span className="officer-info" style={{ fontSize: "20px", fontWeight: "600", color: "#1d77d7" }}>{title}</span>
                    <span className="officer-info" style={{ fontSize: "18px", fontWeight: "700" }}>{name}</span>
                </div>
            </div>
        </div>
    );
};

export default OfficerProfile;